import React from 'react'
import Moment from 'moment-timezone'
import {Button} from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddToPhotos'

import ValueFormatter from '../components/value-formatter'
import Config from '../config'

const numberSort = (num1,num2) => {
  return num1 - num2
}

const getGridConfig = (createNewReturn,actionClickHandler) => {

  let userData = Config.getConfig('userData')

  let gridconfig = {
   
    visibleRowBufferSize : 10,
  
    columnDefs : [
      {
        field: "period_start",
        headerName: "Period Start",
        menuTabs : [],
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        sortable: false,
        filter: 'agDateColumnFilter',
        filterParams : {
          filterOptions : ['inRange','equals','empty'],
          suppressAndOrCondition : true,
          inRangeInclusive : true,
          comparator : function (filter, value) {
            let filterMoment = Moment(filter)
            let valueMoment = Moment(value).tz('Europe/London')
  
            if (valueMoment.isSame(filterMoment,'day')) return 0
            if (valueMoment.isBefore(filterMoment,'day')) return -1
            if (valueMoment.isAfter(filterMoment,'day')) return 1
          },
        },
        width : 120,
      },
      {
        field: "period",
        headerName: "Period End",
        menuTabs : [],
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        sortable: false,
        filter: 'agDateColumnFilter',
        filterParams : {
          filterOptions : ['inRange','equals','empty'],
          suppressAndOrCondition : true,
          inRangeInclusive : true,
          comparator : function (filter, value) {
            let filterMoment = Moment(filter)
            let valueMoment = Moment(value).tz('Europe/London')
  
            if (valueMoment.isSame(filterMoment,'day')) return 0
            if (valueMoment.isBefore(filterMoment,'day')) return -1
            if (valueMoment.isAfter(filterMoment,'day')) return 1
          },
        },
        width : 120,
      },
      {
        field: "vat_on_sales",
        headerName: "Sales VAT",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoney(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "vat_on_acquisitions",
        headerName: "Acquisitions VAT",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoney(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "vat_on_purchases",
        headerName: "Purchases VAT",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoney(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "total_sales",
        headerName: "Gross Sales",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoneyNoDecimal(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "total_purchases",
        headerName: "Gross Purchases",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCell',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoneyNoDecimal(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "vat_due",
        headerName: "VAT Due",
        headerClass : "rightAlignHeader",
        cellClass : 'numberGridCellBold',
        menuTabs : [],
        sortable: false,
        valueFormatter : item => ValueFormatter.formatMoney(item.value),
        comparator: numberSort,
        filter: false,
        width : 120,
      },
      {
        field: "processingDate",
        headerName: "Submitted",
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        menuTabs : [],
        sortable: false,
        filter: false,
        width : 120,
      },
      {
        field: "transaction_date",
        headerName: "Date Paid",
        menuTabs : [],
        valueFormatter : item => ValueFormatter.formatDate(item.value),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams : {
          filterOptions : ['inRange','equals','empty'],
          suppressAndOrCondition : true,
          inRangeInclusive : true,
          comparator : function (filter, value) {
            let filterMoment = Moment(filter)
            let valueMoment = Moment(value).tz('Europe/London')
  
            if (valueMoment.isSame(filterMoment,'day')) return 0
            if (valueMoment.isBefore(filterMoment,'day')) return -1
            if (valueMoment.isAfter(filterMoment,'day')) return 1
          },
        },
        width : 150,
      },
      {
        field: "vat_id",
        headerName: "Action",
        headerComponent: (props) => {
          return userData.edit_right ? 
           (<Button onClick={createNewReturn} color="primary" startIcon={<AddIcon />}>new vat return</Button>) 
           : 
           (
           <div class="ag-cell-label-container">
            <div class="ag-header-cell-label">
                <span class="ag-header-cell-text">Action</span>
            </div>
          </div>)
        },
        cellRenderer: 'invoiceActionCellRenderer',
        cellRendererParams: item => {
          return {
            clicked: actionClickHandler,
            view : true,
            print : true,
            download : true,
            email :false,
            link : item.data.transaction_id
          }
        },
        menuTabs : [],
        filter: false,
        width : 250,
      },
    ]
  }

  return gridconfig
}

export default getGridConfig
